module.exports = __webpack_public_path__ + "img/ychw.b7ff1d40.png";